module.exports = "<div class=q-marg-all-xl> <div class=discrepancies-edit-record-body> </div> <div class=\"q-marg-top-xl edit-error\" style=display:none> <div class=\"q-alert q-alert-red\"> Error editing Discrepancy Record </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/receivingDiscrepancies/html/editDiscrepanciesRecordModalBody.html
// module id = 1392
// module chunks = 1